module.exports = __webpack_public_path__ + "img/dynamicLogo7.c85d74a4.png";